import { render, staticRenderFns } from "./BtnInserirPrestacaoContaFinalLancamento.vue?vue&type=template&id=3525a3a7&"
import script from "./BtnInserirPrestacaoContaFinalLancamento.vue?vue&type=script&lang=js&"
export * from "./BtnInserirPrestacaoContaFinalLancamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports